// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3ZAYl","name":"ConsentHeader_name__10m2a","birthday":"ConsentHeader_birthday__2WSrc","skeleton":"ConsentHeader_skeleton__2c-Mz"};